import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type BookingbarStore = {
  openDatePicker: boolean
  setOpenDatePicker: (open: boolean) => void
  citySlug: string | null
  setCitySlug: (slug: string | null) => void
  countrySlug: string | null
  setCountrySlug: (slug: string | null) => void
  filter: number[] | null
  setFilter: (filter: number[] | null) => void
}

export const useBookingBarStore = create<BookingbarStore>()(
  persist(
    (set) => ({
      openDatePicker: false,
      setOpenDatePicker: (open) => set({ openDatePicker: open }),
      citySlug: null,
      setCitySlug: (slug) => set({ citySlug: slug }),
      countrySlug: null,
      setCountrySlug: (slug) => set({ countrySlug: slug }),
      filter: null,
      setFilter: (filter) => set({ filter }),
    }),
    {
      name: 'booking-bar',
      partialize: (state) => ({
        citySlug: state.citySlug,
        countrySlug: state.countrySlug,
      }),
    },
  ),
)
